import {
	CECA_COLORS,
	CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD,
	CECA_OPTIONS_POSSIBILITIES_WIDTHS
} from './constants';
import { useState, useEffect } from 'react';

export const useScroll = () => {
	const [scroll, setScroll] = useState(0);

	useEffect(() => {
		window.addEventListener('scroll', scrollHandler, {passive:true});
		return () => {
			window.removeEventListener('scroll', scrollHandler);
		};
	});
	const scrollHandler = () => {
		setScroll(window.scrollY);
	};
	return scroll;
};


export function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g,' ');
}

// Options selectors are hidden by editor
// but it is up to findOptions to change the available options
const DEFAULT_OPTIONS = {
	depth: [3,4,5],
	height: [2.75,3.50],

	modules: [1,2,3],
	width0: [3,4,5,6,6.5],
	width1: [3,4,5,6,6.5],//hidden / shown by Editor
	width2: [3,4,5,6,6.5],//hidden / shown by Editor

	wall_front: [false,true],
	door_front: [0,1,2,3],//hidden / shown by Editor
	wall_back: [false,true],
	door_back: [0,1,2,3],//hidden / shown by Editor
	wall_left: [false,true],
	wall_right: [false,true],

	color_roof: colorsToRALs(CECA_COLORS),
	color_walls: colorsToRALs(CECA_COLORS),
	color_accessories: colorsToRALs(CECA_COLORS),

	atg: [false,true],
	atg_device: [false,true],
	transparent: [false,true],
	delivery: [true],

	optional_accessories: 'special_option'
}


function colorsToRALs(colors){
	return colors.map((c=>c.ral));
}
export function ralToColor(ral){
	return CECA_COLORS.find((c)=>(c.ral===ral));
}
function ralToRGB(ral){
	const color = ralToColor(ral);
	if(color){
		return color.rgb;
	}
	return false;
}
export function ralToText(ral){
	const color = ralToColor(ral);
	if(color){
		return color.ral+' - '+color.color_text;
	}
	return undefined;
}

export function findOptions(selected_values){
	if(!selected_values){
		selected_values = findSelectedValues(DEFAULT_OPTIONS);
	}
	const sv = selected_values;
	// Edit options based on the selected values
	const possibles_widths = CECA_OPTIONS_POSSIBILITIES_WIDTHS[
		'p'+sv.depth+((sv.height<CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD)?'b':'o')
	];
	const has_walls = (
		sv.wall_front || sv.wall_back || sv.wall_left || sv.wall_right
	);
	const has_accessories = (
		sv.wall_left || sv.wall_right || sv.door_front || (sv.optional_accessories&&sv.optional_accessories.enabled)
	);
	const options = {
		...DEFAULT_OPTIONS,
		door_front: ((sv.height<CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD)&&sv.wall_front&&(!sv.door_back||!sv.wall_back))?[...Array(sv.modules+1).keys()]:[0],
		door_back: ((sv.height<CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD)&&sv.wall_back&&(!sv.door_front||!sv.wall_front))?[...Array(sv.modules+1).keys()]:[0],
		width0: possibles_widths,
		width1: possibles_widths,
		width2: possibles_widths,
		color_roof: colorsToRALs(selected_values.atg?CECA_COLORS.filter((c)=>c.atg):CECA_COLORS),
		color_walls: colorsToRALs(has_walls?CECA_COLORS:[]),
		color_accessories: colorsToRALs(has_accessories?CECA_COLORS:[]),
		atg_device: sv.atg?DEFAULT_OPTIONS.atg_device:[]
	}
	// return the clean options
	return options;
}
const default_selected_values = {
	color_roof: "5008",
	color_walls: "9006",
	color_accessories: "7015"
}
export function findSelectedValues(options,preflight_selected_values){
	const found_selected_values = {};
	const defaulted_preflight_selected_values = {
		...default_selected_values,
		...(preflight_selected_values||{})
	};
	const dpsv = defaulted_preflight_selected_values;
	Object.keys(options).forEach((key)=>{
		if(options[key] === 'special_option'){
			found_selected_values[key] = defaulted_preflight_selected_values[key];
		}else{
			// By default, the first value
			let selected_value = options[key][0];
			// Preferably, the selected value
			if(dpsv && dpsv.hasOwnProperty(key)){
				if(options[key].includes(dpsv[key])){
					selected_value = dpsv[key];
				}
			}
			if(typeof selected_value !== 'undefined'){
				found_selected_values[key] = selected_value;
			}
		}
	});
	return found_selected_values;
}



export function getLocationHashStrFromData(obj){
	const encoded = encodeURIComponent(JSON.stringify(obj));
	// console.log(obj);
	// console.log(encoded);

	window.hash_storage = encoded;
	return encoded;
}

function decodeLocationHashStr(str){
	try{
		if(typeof str === 'string' && str.length){
			return JSON.parse(decodeURIComponent(str));
		}
	}catch(e){
	}
	return false;
}
export function getDataFromLocationHash(){
	let decoded = false;
	if(window.location.hash && window.location.hash.length > 1){
		decoded = decodeLocationHashStr(window.location.hash.substring(1));
	}
	return decoded;
}

function getQueryVariable(variable){
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] === variable){return pair[1];}
       }
       return(false);
}
export function findSelectedValuesOverwrites(){
	const preconfig_str = getQueryVariable('preconfiguration');
	const preconfigs = {
		'camping-car-s': {
			depth: DEFAULT_OPTIONS.depth[0],
			height: DEFAULT_OPTIONS.height[1],
			width0: DEFAULT_OPTIONS.width0[3]
		},
		'camping-car': {
			depth: DEFAULT_OPTIONS.depth[1],
			height: DEFAULT_OPTIONS.height[1],
			modules: 2,
			width0: DEFAULT_OPTIONS.width0[1],
			width1: DEFAULT_OPTIONS.width1[1]
		},
		'c3': {
			depth: DEFAULT_OPTIONS.depth[1],
			height: DEFAULT_OPTIONS.height[1],
			modules: 2,
			width0: DEFAULT_OPTIONS.width0[1],
			width1: DEFAULT_OPTIONS.width1[1]
		},
		'c2': {
			depth: DEFAULT_OPTIONS.depth[2],
			height: DEFAULT_OPTIONS.height[0],
			width0: DEFAULT_OPTIONS.width0[1],
			wall_front: DEFAULT_OPTIONS.wall_front[1],
			wall_back: DEFAULT_OPTIONS.wall_back[1],
			wall_left: DEFAULT_OPTIONS.wall_left[1],
			wall_right: DEFAULT_OPTIONS.wall_right[1],
			door_front: DEFAULT_OPTIONS.door_front[1]
		},
		'c1': {
			depth: DEFAULT_OPTIONS.depth[2],
			height: DEFAULT_OPTIONS.height[0],
			width0: DEFAULT_OPTIONS.width0[2]
		},
		'c0': {
			depth: DEFAULT_OPTIONS.depth[1],
			height: DEFAULT_OPTIONS.height[1],
			modules: 2,
			width0: DEFAULT_OPTIONS.width0[1],
			width1: DEFAULT_OPTIONS.width1[0],
			wall_front: DEFAULT_OPTIONS.wall_front[1],
			wall_back: DEFAULT_OPTIONS.wall_back[1]
		},
		'standard': {
			depth: DEFAULT_OPTIONS.depth[2],
			height: DEFAULT_OPTIONS.height[0],
			width0: DEFAULT_OPTIONS.width0[1]
		},
		'standard-s': {
			depth: DEFAULT_OPTIONS.depth[1],
			height: DEFAULT_OPTIONS.height[0],
			width0: DEFAULT_OPTIONS.width0[0]
		},
		'm3': {
			depth: DEFAULT_OPTIONS.depth[0]
		},
		'm4': {
			depth: DEFAULT_OPTIONS.depth[1]
		},
		'm5': {
			depth: DEFAULT_OPTIONS.depth[2]
		},
		'entry': {
		}
	};
	return (preconfig_str&&preconfigs[preconfig_str])||{};
}


export function scrollTop(smooth){
	if(window.scrollY > 0){
		const supports_smooth_scroll = 'scrollBehavior' in document.documentElement.style;
		if(supports_smooth_scroll && smooth){
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
		}else{
			window.scrollTo(0,0);
		}
	}
}


const modules_rotation_x = 3.5;
const wall_rotation_x = 3.5;
const camera_settings_overrides = {
	default: {
	},
	height: {
		rotation_y: -0.35
	},
	width0: {
		// target: 'module0',
		rotation_x: modules_rotation_x
	},
	width1: {
		// target: 'module1',
		rotation_x: modules_rotation_x
	},
	width2: {
		// target: 'module2',
		rotation_x: modules_rotation_x
	},
	color_roof: {
		rotation_x: modules_rotation_x
	},
	wall_front: {
		target: 'front',
		rotation_x: wall_rotation_x
		//no_arrows: true
	},
	door_front: {
		target: 'front',
		rotation_x: wall_rotation_x
		//no_arrows: true
	},
	wall_left: {
		target: 'left',
		rotation_x: wall_rotation_x-Math.PI*.5,
		//no_arrows: true,
		reverse_arrows: ['side']
	},
	wall_back: {
		target: 'back',
		rotation_x: wall_rotation_x-Math.PI,
		//no_arrows: true,
		reverse_arrows: ['endwall','side']
	},
	door_back: {
		target: 'back',
		rotation_x: wall_rotation_x-Math.PI,
		//no_arrows: true,
		reverse_arrows: ['endwall','side']
	},
	wall_right: {
		target: 'right',
		rotation_y: -0.25,
		rotation_x: wall_rotation_x-Math.PI*1.5,
		reverse_arrows: ['endwall']
		//no_arrows: true
	}
}
export function makeBIGSettings(settings){


	const camera_settings = {
		rotation_x: 4,
		rotation_y: -0.5,
		target_y: settings.height/2,
		rotation_y_max: 0, //-0.4
		rotation_y_min: -Math.PI/2, //-0.4
		lens_length: 50,
		...camera_settings_overrides[settings.active_step]||{},
		target: 'global'// trop perturbant sinon
	}

	const modules_type = [
		['P305_H255_2022','P305_H330_2022'],
		['P405_H255_2022','P405_H330_2022'],
		['P505_H255_2022','P505_H330_2022']
	][settings.depth-3][(settings.height<CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD)?0:1];

	const modules = [];
	for (var m = (settings.modules-1); m >= 0; m--) {
		modules.push({
			width: settings['width'+m],
			transparent: settings['transparent'],
			left: {
				activated: settings.wall_left && m===0,
				door: false
			},
			right: {
				activated: settings.wall_right && m===(settings.modules-1),
				door: false
			},
			front: {
				activated: settings.wall_front,
				door: settings.door_front>m
			},
			back: {
				activated: settings.wall_back,
				door: settings.door_back>m
			}
		});
	}

	return {
		renderer: {
            color: 0xFFFFFF,
            height: settings.renderer_height,
            width: settings.renderer_width,
            shadow_opacity: 0.1
        },
        camera: camera_settings,
        light: {
            rotation_x: 0.2,
            rotation_x_relative: true
        },
		building: {
			type: 'abri',
			hide_doors: false,//false
			modules_type: modules_type,
			display_arrows: camera_settings.no_arrows?false:['sections','depth','height'],
			reverse_arrows: camera_settings.reverse_arrows,
		    colors: {
		        roofing: ralToRGB(settings.color_roof),
		        roofing_accessories: ralToRGB(settings.color_accessories),
		        walls: ralToRGB(settings.color_walls),
		        walls_accessories: ralToRGB(settings.color_accessories)
		    },
			modules: modules
		}
	}
}
